import React, { Component } from 'react';
import Select from 'react-select';
import { Row, Col, Table, Panel, PanelGroup, Popover, OverlayTrigger } from "react-bootstrap";
import { toast } from 'react-toastify';

import { ConsultaAcademicosEst, ConsultaSemestres, DeleteHist, UploadXlsHist, ConsultaCeldas, GuardarCeldas } from "../../../funciones/HistoricoFunction";
import ModalForm from "../../../components/Modal/ModalForm";
import CustomModal from "../../../components/Modal/CustomModal";

import EditHistorico from "./EditHistorico";
import EditHistoricoAddMat from "./EditHistoricoAddMat";

let idHist = {
    carrera: "",
    semestre: "",
    semestreName: "",
    carreraName: "",
    SemestreId: ""
}

class HistoricoEst extends Component {
    state = {
        carreras: [],
        materias: [],
        semestres: [],
        literales: [],
        textCarreras: <React.Fragment><i className ="fa fa-spinner fa-spin"></i> Buscando las carreras del estudiante</React.Fragment>,
        btnDown: true,
        iconChevron: "fa fa-chevron-down",
        valorSemestre: { value: '', label: '- Selecciona un Semestre -' },
        semestresDisp: [{ value: '', label: ' - Cargando Espere - ', carrera: '', nombre: '' }],
        openW: false,
        openW2: false,
        openDelHist: false,
        semestreSelect: "",
        semestreSelect2: "",
        botonDel: {
            icon: "fa fa-check",
            text: "Si"
        },
        botonXls: {
            icon: "fa fa-file-excel-o",
            text: "Cargar Archivo"
        },
        botonSConfig: {
            icon: "fa fa-save",
            text: "Guardar Cambios"
        },
        SConfig: false,
        celCed: "",
        celCarr: "",
        fila1: "",
        may: "",
        jun: "",
        ago: "",
        codigo: "",
        sa: "",
        nota: "",
        hoja: "",
        cantErrores: "",
    }

    constructor (props) {
        super(props);
        ConsultaAcademicosEst(this.props.est.id, (resp) => {

            this.setState({
                carreras: resp[0],
                materias: resp[1],
                semestres: resp[2],
                literales: resp[3],
                openDelHist: false,
            })
        })

        ConsultaSemestres ((resp) => {
            this.setState({
                semestresDisp: resp,
                openDelHist: false,
            })
        })

        ConsultaCeldas ((resp) => {
            this.setState({
                celCed: resp.ced,
                celCarr: resp.carrera,
                fila1: resp.sem,
                may: resp.may,
                jun: resp.jun,
                ago: resp.ago,
                codigo: resp.codigo,
                sa: resp.sa,
                nota: resp.nota, 
                hoja: resp.hoja
            })
        })
    }

    cambiaValor = (prop) => (event) => {
        this.setState({
            [prop]: (event.target.value).toUpperCase(),
        });
    };

    cambiaIcon = () => {
        this.setState ({
            btnDown: !this.state.btnDown,
            openDelHist: false,
        }, () => {
            (this.state.btnDown === true) ? this.setState({iconChevron: "fa fa-chevron-down"}) : this.setState({iconChevron: "fa fa-chevron-up"})
        })
    }

    contenidoModal = (semestre) => (<EditHistorico datSemestre= {semestre} est ={this.props.est}/>);
    contenidoModal2 = (semestre) => (<EditHistoricoAddMat datSemestre= {semestre} est ={this.props.est}/>);

    showModal = () => {
        const { openW, semestreSelect } = this.state;
        
        return (
            <ModalForm
                isopen =  {openW}
                titulo = {<div style={{fontSize:14}}>Editar Calificaciones Históricas del <strong>{semestreSelect.label}</strong> en <strong>{semestreSelect.nombre}</strong></div>}
                contenido = {this.contenidoModal(semestreSelect)}
                cerrar = {this.cerrarModal}
            />
        );
    }

    addMat = () => {
        const { openW2, semestreSelect2 } = this.state;
        return (
            <ModalForm
                isopen =  {openW2}
                titulo = {<div style={{fontSize:14}}>Añadir nueva calificacion a <strong>{semestreSelect2.nombre}</strong> en <strong>{semestreSelect2.carrera}</strong></div>}
                contenido = {this.contenidoModal2(semestreSelect2)}
                cerrar = {this.cerrarModal}
            />
        );
    }

    openModal2 = (nombre) => {
        this.setState ({
            openDelHist: false,
            openW2: true,
            openW: false,
            semestreSelect2: nombre,
        })
    }

    openModal = (nombre) => {
        this.setState ({
            openDelHist: false,
            openW2: false,
            openW: true,
            semestreSelect: nombre,
        })
    }

    cerrarModal = () => {
        ConsultaAcademicosEst(this.props.est.id, (resp) => {
            this.setState({
                carreras: resp[0],
                materias: resp[1],
                semestres: resp[2],
                literales: resp[3],
                openW: false,
                openW2: false,
                openDelHist: false,
            })
        })
    }

    valorSelectSemestres = (valorSemestre) => {
        this.setState({
            valorSemestre,
            openDelHist: false,
        }, () => {
            this.openModal(valorSemestre)
        });
    }

    openModalSemesre = (semId, value, label, nombre, carrera) => (e) => {
        let valor = {
            value: value,
            label: label,
            carrera: carrera,
            nombre: nombre,
            SemestreId: semId
        }
        this.openModal(valor)
    }

    openModalAddMat = (semId, value, label, nombre, carrera) => (e) => {
        let valor = {
            value: value,
            label: label,
            carrera: carrera,
            nombre: nombre,
            SemestreId: semId
        }
        
        this.openModal2(valor)
    }

    openDel = (semId, carrera, value, label, nombre) => (e) => {
        idHist = {
            carrera: carrera,
            semestre: value,
            semestreName: label,
            carreraName: nombre,
            SemestreId: semId
        }
        this.setState({
            botonDel: {
                icon: "fa fa-check",
                text: "Si"
            },
            openDelHist: true
        })
    }

    openAdd = (carrera, value, label, nombre) => (e) => {

    }

    respGuardar = (resp) => {
        let mensaje = resp[1];
        let errores = resp[2];
        let nameErrores = resp[3]
        let contentErr = [];
        
        let erroresList = (
            <Popover bsSize="large" title="Errores Encontrados" id="erroresList">
                {contentErr}
            </Popover>
        )

        let Ok = (mensaje) => {
            let statusC = true;
            if (mensaje.status !== "error") statusC = false;

            this.setState({
                botonSConfig: {
                    icon: "fa fa-save",
                    text: "Guardar Cambios"
                },
                SConfig: statusC,
            }, () => {
                toast[mensaje.status](mensaje.mensaje,{autoClose: 4000});
            })
        }

        for (let i in nameErrores) {
            if (nameErrores[i] !== "") contentErr.push(
                <div key = {i} className="text-danger" style={{fontSize:10, marginBottom:8}}><i className="fa fa-exclamation-triangle"></i> {nameErrores[i]}</div>
            )
        }

        if (errores === 0) this.setState({ cantErrores:"" })
        if (mensaje[0].status === "error" && errores !== 0) this.setState ({
            cantErrores: <div style={{paddingTop:10}}>
                            Se han encontrado {errores} error(es). Haz click <span>
                            <OverlayTrigger trigger="focus" placement="top" overlay={erroresList}>
                                <button style={{borderWidth: 1}} className="btn btn-danger btn-xs">Aqui</button> 
                            </OverlayTrigger></span> para verlos
                        </div>
        })

        Ok(mensaje[0]);
    }

    configCeldas = () => {

        let { botonSConfig, SConfig, celCed, celCarr, fila1, may, jun, ago, codigo, sa, nota, hoja, cantErrores } = this.state;
        let campos = { celCed, celCarr, fila1, may, jun, ago, codigo, sa, nota, hoja };

        let contenidoModal = <React.Fragment>
            <Row>
                <Col md={2}>
                    <input type="text" className="form-control" value={celCed} onChange={this.cambiaValor("celCed")}/>
                    <div className="text-muted" style={{fontSize: 9}}>Celda Cédula</div>
                </Col>
                <Col md={2}>
                    <input type="text" className="form-control" value={celCarr} onChange={this.cambiaValor("celCarr")}/>
                    <div className="text-muted" style={{fontSize: 9}}>Celda Carrera</div>
                </Col>
                <Col md={2}>
                    <input type="text" className="form-control" value={fila1} onChange={this.cambiaValor("fila1")}/>
                    <div className="text-muted" style={{fontSize: 9}}>Primera Fila del Histórico</div>
                </Col>
                <Col md={6}>
                    <input type="text" className="form-control" value={hoja} onChange={this.cambiaValor("hoja")}/>
                    <div className="text-muted" style={{fontSize: 9}}>Nombre de la Hoja</div>
                </Col>
                <Col md={12} className="text-primary">Definir Columnas</Col>
                
                <Col md={2}>
                    <input type="text" className="form-control" value={may} onChange={this.cambiaValor("may")}/>
                    <div className="text-muted" style={{fontSize: 9}}>MAY</div>
                </Col>
                <Col md={2}>
                    <input type="text" className="form-control" value={jun} onChange={this.cambiaValor("jun")}/>
                    <div className="text-muted" style={{fontSize: 9}}>JUN</div>
                </Col>
                <Col md={2}>
                    <input type="text" className="form-control" value={ago} onChange={this.cambiaValor("ago")}/>
                    <div className="text-muted" style={{fontSize: 9}}>AGO</div>
                </Col>
                <Col md={2}>
                    <input type="text" className="form-control" value={codigo} onChange={this.cambiaValor("codigo")}/>
                    <div className="text-muted" style={{fontSize: 9}}>CÓDIGO</div>
                </Col>
                <Col md={2}>
                    <input type="text" className="form-control" value={sa} onChange={this.cambiaValor("sa")}/>
                    <div className="text-muted" style={{fontSize: 9}}>S.A.</div>
                </Col>
                <Col md={2}>
                    <input type="text" className="form-control" value={nota} onChange={this.cambiaValor("nota")}/>
                    <div className="text-muted" style={{fontSize: 9}}>NOTA</div>
                </Col>
                <Col md={12} className="text-danger custom-mt-20" style={{fontSize: 10}} align="justify">
                    <strong>Cuidado: </strong> Esta función es de uso delicado y puede ocasionar fallas al sistema o pérdida de notas del archivo histórico si no se usa adecuadamente
                </Col>
                <Col md={12} className="text-danger" style={{fontSize: 10}} align="justify">{cantErrores}</Col>
            </Row>
        </React.Fragment>

        return (
            <CustomModal
                isopen =  {SConfig}
                titulo = {<div className="text-primary">Configuración de las Celdas</div>}
                contenido = {contenidoModal}
                boton1 = {<React.Fragment><i className={botonSConfig.icon}></i> {botonSConfig.text}</React.Fragment>}
                boton2 = ""
                funcion1 = { () => {
                    this.setState({
                        botonSConfig: {
                            icon: "fa fa-spinner fa-spin",
                            text: "Espera"
                        }
                    }, () => {
                        GuardarCeldas (campos, (resp) => {
                            this.respGuardar(resp)
                        })
                    })
                }}
            />
        )
    }

    openConfigCeldas = () => (e) => {
        this.setState({SConfig: true})
    }


    delHistorico = () => {
        let { botonDel } = this.state;
        let { est } = this.props;

        let contenidoModal = <div>
            ¿Desea realmente <strong>eliminar el Histórico <span className="text-danger">{`${idHist.semestreName} [${idHist.carreraName}]`}</span></strong> del Sistema?
            <div style={{fontSize:9}}>ESta opción no puede deshacerse y puede ocasionar fallas al sistema</div>
            </div>

        return (
            <CustomModal
                isopen =  {this.state.openDelHist}
                titulo = {<div className="text-primary">Confirmación</div>}
                contenido = {contenidoModal}
                boton1 = {<React.Fragment><i className={botonDel.icon}></i> {botonDel.text}</React.Fragment>}
                boton2 = {<React.Fragment><i className="fa fa-times"></i> No</React.Fragment>}
                funcion1 = { () => {
                    this.setState({
                        botonDel: {
                            icon: "fa fa-spinner fa-spin",
                            text: "Espera"
                        }
                    })
                    
                    DeleteHist(idHist.SemestreId, est.id, idHist.carrera, idHist.semestre, () => {
                        
                        ConsultaAcademicosEst(this.props.est.id, (resp) => {
                            this.setState({
                                carreras: resp[0],
                                materias: resp[1],
                                semestres: resp[2],
                                literales: resp[3],
                                openDelHist: false,
                            })
                        })
                        
                        toast.info("El Histórico del periodo fue eliminado exisosamente",{autoClose: 4000});
                    
                })}}/>
        );
    }

    uploadFile = (carr) => (e) => {
        let archivo = document.getElementById("upXlsHist").value;
        let extension = archivo.split('.').pop();
        let ext = extension.toLowerCase();
        if (archivo === ""){ toast.error("No has seleccionado ningún archivo",{autoClose: 4000}); return null }
        let updFile = () => {            
            this.setState ({
                botonXls: {
                    icon: "fa fa-spinner fa-spin",
                    text: "Cargando el archivo"
                }
            }, () => {
                UploadXlsHist(document.getElementById("upXlsHist"), carr, this.props.est.id, (resp)=> {
                    if (resp.status === "error") {
                        this.setState({
                            botonXls: {
                                icon: "fa fa-file-excel-o",
                                text: "Cargar Archivo"
                            }
                        }, () => {
                            toast.error(resp.mess,{autoClose: 8000});
                            document.getElementById("upXlsHist").value = "";
                        })
                    }else{
                        /* console.log(resp) */
                        this.setState({
                            botonXls: {
                                icon: "fa fa-file-excel-o",
                                text: "Cargar Archivo"
                            }
                        }, () => {
                            toast.info(resp.mess,{autoClose: 10000});
                            document.getElementById("upXlsHist").value = "";
                            ConsultaAcademicosEst(this.props.est.id, (resp) => {
                                this.setState({
                                    carreras: resp[0],
                                    materias: resp[1],
                                    semestres: resp[2],
                                    literales: resp[3],
                                    openDelHist: false,
                                })
                            })
                        })
                    }
                })
            })
        }

        if (ext === "xls" || ext === "xlsx"){
            updFile();
        }else{
            toast.error("No has seleccionado un archivo .xls o .xlsx", {autoClose: 4000});
            document.getElementById("upXlsHist").value = "";
            return null
        }
    }

    selectFile = () => (e) => {
        document.getElementById("upXlsHist").click();
    }

    botonXls = (carr) => {
        let { botonXls } = this.state;
        return (
            <React.Fragment>
                <div className="btn-group">
                    <button className="btn btn-success" onClick={this.selectFile()} title="Permite cargar las calificaciones históricas a partir de un archivo .xls" style={{borderWidth: 1}}><i className={botonXls.icon}></i> {botonXls.text}</button>
                    <button className="btn btn-warning" onClick={this.openConfigCeldas()} title="Definir las celdas que serán cargadas a partir del archivo .xls"  style={{borderWidth: 1}}><i className="fa fa-search"></i> Ver Celdas</button>
                </div>
                <input type="file" id="upXlsHist" onChange= {this.uploadFile(carr)} className="form-control" style={{ display: "none"}}/>
            </React.Fragment>
        )
    }

    carreras = () => {
        let { carreras, textCarreras, iconChevron, valorSemestre } = this.state;
        const styles = {
            padding: 5, fontSize: 10
        }

        if (carreras.length === 0) return (
            <div align="center" className="custom-color custom-mt-10">{textCarreras}</div>
        )

        let materias = (idCarrera) => {
            let { materias, semestres, literales } = this.state;
            let SemContent = [];

            let enLetras= (nota) => {
                let letras = [
                    "UNO", "DOS", "TRES", "CUATRO", "CINCO", "SEIS", "SIETE", "OCHO", "NUEVE", "DIEZ",
                    "ONCE", "DOCE", "TRECE", "CATORCE", "QUINCE", "DIECISEIS", "DIECISIETE", "DIECIOCHO",
                    "DIECINUEVE", "VEINTE"
                ];

                return letras[nota - 1]
            }

            let mes = (num) => {
                let meses = ["ENE", "FEB", "MAR", "ABR", "MAY", "JUN", "JUL", "AGO", "SEP", "OCT", "NOV", "DIC"]
                
                return meses[num - 1]
            }

            let tdCualiCuanti = (tipo, nota) => {
                if (tipo === 1) return (
                    <React.Fragment>
                        <td align="center" style={styles}>{nota}</td>
                        <td align="center" style={styles}>{enLetras(nota)}</td>
                    </React.Fragment>
                )

                if (nota === "" || nota === "0") return (
                    <td align="center" colSpan={2} style={styles}></td>
                )

                return (
                    <td align="center" colSpan={2} style={styles}>{literales[parseInt(nota) - 1].literal}</td>
                )
            }

            let materiasSem = (semId) => {
                let materiasContent = [];
                for (let i in materias) {
                    if (idCarrera === materias[i].carrera_id && semId === materias[i].semestre_id) materiasContent.push (
                        <tr key={materias[i].id}>
                            <td align="center" style={{padding: 5, fontSize: 8}}>{materias[i].codigo}</td>
                            <td style={styles}>{materias[i].materia_name}</td>
                            <td align="center" style={styles}>{`${mes(materias[i].corte_name)} ${materias[i].corte_year}`}</td>
                            <td align="center" style={styles}>{materias[i].tipoev_name}</td>
                            {tdCualiCuanti(materias[i].cuantitativo, materias[i].nota)}
                        </tr>
                    )
                }

                return materiasContent;
            }

            let opcionAdd = (semId, carrera, value, label, nombre) => {
                let notaApl = false;
                for (let i in materias) {
                    if (idCarrera === materias[i].carrera_id && value === materias[i].semestre_num){
                        switch (materias[i].cuantitativo) {
                            case 0:
                                let aprueba = 0
                                if (materias[i].nota !== "" && materias[i].nota !== "0") {
                                    aprueba = literales[parseInt(materias[i].nota) - 1].aprueba;
                                }
                                if (aprueba === 0)  notaApl = true;
                            break;
                            case 1:
                                if (parseInt(materias[i].nota) < parseInt(materias[i].nota_min)) notaApl = true;
                            break;
                            default: break;
                        }
                    }
                }

                if (notaApl === false) return null;

                return (
                    <div className="text-primary" onClick={this.openModalAddMat(semId, carrera, value, label, nombre)} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Esta opción permite agregar una calificación específica de una materia aplazada"><i className="fa fa-plus-square"></i> Calificación (Mat. Aplazada)</div>
                )
             }

            let acciones = (semId, value, label, nombre, carrera) => (
                <Popover bsSize="large" id="acciones">
                    <div className="text-warning" onClick={this.openModalSemesre(semId, value, label, nombre, carrera)} style={{cursor:"pointer", fontSize: 13, padding: 5}} title="Esta opcion permite editar los datos de esta materia"><i className="fa fa-edit"></i> Editar este Histórico</div>
                    <div className="text-danger" onClick={this.openDel(semId, carrera, value, label, nombre)} style={{cursor:"pointer", fontSize: 12, padding: 5}} title="Esta opción permite eliminar los datos históricos de este periodo"><i className="fa fa-trash"></i> Eliminar este Histórico</div>
                    {opcionAdd(semId, carrera, value, label, nombre)}
                </Popover>
            )

            for (let i in semestres) {
                if (idCarrera === semestres[i].carrera_id) SemContent.push (
                    <div key={i} className="custom-sem-historico">
                        <div style={{padding: 5}}>
                            <Row>
                                <Col md={7} style={{paddingTop:10, paddingLeft: 20}}>
                                    <strong style={{marginTop:5}} className="text-danger">{semestres[i].semestre_name}</strong>
                                </Col>
                                <Col md={5} align="right">
                                    <OverlayTrigger trigger="focus" placement="right" overlay={
                                        acciones(semestres[i].semestre_id, semestres[i].semestre_num, semestres[i].semestre_name, semestres[i].carrera_name, semestres[i].carrera_id)
                                    }>
                                        <button className="btn btn-primary" style={{borderWidth: 1}}><i className="fa fa-gear"></i> Acciones</button>
                                    </OverlayTrigger>
                                </Col>
                            </Row>
                        </div>
                        <div className="custom-mt-10">
                            <div className="table-responsive" style={{backgroundColor:"#FFF"}}>
                                <Table striped hover bordered>
                                    <tbody>
                                        <tr className="custon-back-color">
                                            <td align="center" width="10%" style={styles}><strong>CÓDIGO</strong></td>
                                            <td width="45%" style={styles}><strong>MATERIA</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>PERIODO</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>T-E</strong></td>
                                            <td align="center" width="10%" style={styles}><strong>NOTA</strong></td>
                                            <td align="center" width="15%" style={styles}><strong>LETRAS</strong></td>
                                        </tr>
                                        {materiasSem(semestres[i].semestre_id)}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </div>
                )
            }

            if (semestres.length === 0) return (<div align="center">No existen periodos registrados en esta carrera</div>)

            return SemContent;
        }

        let semestresCarrera = (carrera) => {
            let { semestresDisp } = this.state;
            let semestres = [];
            for (let i in semestresDisp) {
                if (semestresDisp[i].carrera === carrera) semestres.push(semestresDisp[i])
            }
            
            return semestres;
        }

        let carrerasList = () => (
            carreras.map(option => (
                <Panel eventKey={option.id} key ={option.id} style={{marginBottom:5, marginTop: 5}}>
                    <Panel.Heading>
                        <Panel.Title toggle className="custom-color" onClick={this.cambiaIcon}>
                            <Row>
                                <Col md={10} style={{fontSize: 12}}>
                                    <strong>{option.carrera_name}</strong>
                                </Col>
                                <Col md={2} align="right">
                                    <i className={iconChevron}></i>
                                </Col>
                            </Row>
                        </Panel.Title>
                    </Panel.Heading>
                    <Panel.Body collapsible style={{paddingLeft:5, paddingRight:5, paddingTop:10}}>
                        <div align="right" className="text-danger" style={{marginBottom: 10, padding: 5}}>Cargar calificaciones a partir de un archivo <i className="fa fa-angle-right"></i> {this.botonXls(option)}</div>
                        <div className="custom-alert-info" style={{marginBottom: 10, padding: 5}}>
                            <Row>
                                <Col md={7} style={{paddingTop: 10}}>
                                    Selecciona un periodo para añadir el histórico
                                </Col>
                                <Col md={5}>
                                    <Select
                                        isSearchable ={true}
                                        value={valorSemestre}
                                        onChange={this.valorSelectSemestres}
                                        options={ semestresCarrera(option.id) }
                                    />
                                </Col>
                            </Row>
                        </div>
                        {materias(option.id)}
                    </Panel.Body>
                </Panel>
            ))
        )

        return (
            <PanelGroup accordion activeKey={this.state.activeKey} className="custom-alert-info" id="semestres">
                {carrerasList()}
            </PanelGroup>
        )
    }
    
    render() {
        let { est } = this.props;
        return (
            <React.Fragment>
                <div className="custom-mt-10">
                    <div className="custom-alert-warning"> Datos del Estudiante</div>
                    <Row style={{padding: 10}}>
                        <Col md={7}>
                            <span className="text-danger" style={{fontSize:10}}>Nombres y Apellido: </span>
                            <span className="text-muted" style={{fontSize:10}}>{est.nombre}</span>
                        </Col>
                        <Col md={5} align="right">
                            <span className="text-danger" style={{fontSize:10}}>Cédula de Identidad: </span>
                            <span className="text-muted" style={{fontSize:10}}>{est.ci}</span>
                        </Col>
                    </Row>

                    <div className="custom-alert-warning custom-mt-10">Carreras Registradas del Estudiante</div>
                    <div className="custom-mt-10">
                        {this.carreras()}
                    </div>
                </div>
                {this.showModal()}
                {this.delHistorico()}
                {this.addMat()}
                {this.configCeldas()}
            </React.Fragment>
        );
    }
}
 
export default HistoricoEst;


// WEBPACK FOOTER //
// ./src/views/Registros/HistoricoContent/HistoricoEst.jsx